import { commonApi } from '@common/utils/baseQuery';
import config from '@config';

export interface IPopularOutcome {
  isPopular: boolean;
  percent?: number;
}

export type IPopularOutcomes = Record<string, Record<string, IPopularOutcome>>;

export const popularOutcomesApi = commonApi.injectEndpoints({
  endpoints: (builder) => ({
    getPopularOutcomes: builder.query<IPopularOutcomes, string>({
      query: (eventIds) => `${config.host}/popularoutcomes/?eventIds=${eventIds}&shares=1`,
      transformResponse: (response: unknown) => (
        response && typeof response === 'object' && !Array.isArray(response) ? response as IPopularOutcomes : {}
      ),
    }),
  }),
});
